<template>
  <v-container fluid class="black--text" style="position: relative">
    <filter-summary :targetName="refName"></filter-summary>
    <VueTabulator v-model="data" :options="options" class="font-weight-medium"/>
    <Action :top="topAction" :right="rightAction" :actions="actions" :actionItems="actionItems" />
  </v-container>
</template>

<script>
import FilterSummary from '@/components/tabulator/FilterSummary'
import Action from '@/components/tabulator/action/Action'

export default {
  components: {
    FilterSummary,
    Action
  },
  props: {
    refName: String,
    data: Array,
    options: Object,
    topAction: Number,
    rightAction: Number,
    actions: Boolean,
    actionItems: Array
  }
}
</script>

<style scoped>

</style>
